import { render, staticRenderFns } from "./SecuritySettings.vue?vue&type=template&id=4e527934&"
import script from "./SecuritySettings.vue?vue&type=script&lang=js&"
export * from "./SecuritySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports